import { Grid, Skeleton } from '@joinrepublic/dls-ui-kit';

export interface ISecondaryMarketTableLoaderProps {
  limit: number;
}

export const SecondaryMarketTableLoader = ({
  limit = 8,
}: ISecondaryMarketTableLoaderProps) => {
  const dealsPerColumn = Math.ceil(limit / 2);

  return (
    <Grid
      templateColumns={{ base: '1fr', md: '1fr 1fr' }}
      columnGap={{ base: '8', sm: '5%', lg: '7%' }}
      overflow="hidden"
    >
      {Array.from({ length: 2 }).map((_, index) => (
        <div key={index}>
          {Array.from({ length: dealsPerColumn }).map((_j, dealIndex) => (
            <Grid
              key={dealIndex}
              data-testid="skeleton-deal-row"
              templateColumns="max-content 1fr"
              alignItems="center"
              gap={{ base: '4', sm: '5', lg: '7' }}
              py={{ base: '3', sm: '5' }}
              boxShadow="0 1px 0 0 rgb(0 0 0 / 7%)"
            >
              <Skeleton
                boxSize={{ base: '8', sm: '14' }}
                bgColor="grey.50"
                borderRadius="md"
                opacity="0.6"
              />
              <Skeleton
                h={{ base: '5', sm: '7' }}
                bgColor="grey.50"
                borderRadius={{ base: 'sm', sm: 'md' }}
                opacity="0.6"
              />
            </Grid>
          ))}
        </div>
      ))}
    </Grid>
  );
};
